import React from "react";
import { Icon } from "@thetreep/ui";
import Markdown from "markdown-to-jsx";
import { Link } from "react-router";

const markdownOptions = {
  forceBlock: true,
  overrides: {
    a: {
      component: ({
        href,
        children,
        ...props
      }: {
        href?: string;
        children: React.ReactNode;
        [key: string]: unknown;
      }) => {
        if (href?.startsWith("/")) {
          return (
            <Link to={href} {...props} className="underline">
              {children}
            </Link>
          );
        }

        return (
          <a href={href} className="underline" {...props}>
            {children}
          </a>
        );
      },
    },
    ol: {
      props: {
        className: "list-decimal pl-4 ml-2",
      },
    },
    ul: {
      props: {
        className: "list-disc pl-4 ml-2",
      },
    },
    table: {
      props: {
        className: "w-full border-collapse mt-4 mb-4",
      },
    },
    th: {
      props: {
        className: "px-2 py-1 border border-[#B0B9D1]",
      },
    },
    td: {
      props: {
        className: "px-2 py-1 border border-[#B0B9D1]",
      },
    },
  },
};

interface QuestionAnswerBlockProps {
  index: number;
  question: string;
  answer: string;
  isOpened: boolean;
  setIsOpened: (index: number, isOpened: boolean) => void;
  className?: string;
}

export function QuestionAnswerBlock({
  index,
  question,
  answer,
  isOpened,
  setIsOpened,
  className = "",
}: QuestionAnswerBlockProps) {
  return (
    <li className={className}>
      <details open>
        <summary
          className="font-jakarta text-[16px] md:text-[24px] flex items-center gap-2 justify-between cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
            setIsOpened(index, !isOpened);
          }}
        >
          {question}
          <div
            className={`transform transition-transform duration-500 ${
              isOpened ? "rotate-180" : ""
            }`}
          >
            <Icon size={24} src="down_line" color="#0C419A" />
          </div>
        </summary>

        <div
          className={`overflow-hidden transition-all duration-500 ${
            isOpened ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
          }`}
        >
          {isOpened && (
            <div className="text-text-strong text-[14px] md:text-[16px] mt-6">
              <Markdown options={markdownOptions}>{answer}</Markdown>
            </div>
          )}
        </div>
      </details>
    </li>
  );
}
